'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { useCommentsContext } from '@/contexts/comments.context';
import { useListComments } from '@/hooks/queries/comment.query';
import { useCommentParams } from '@/hooks/use-comment-params';
import { Comment } from './comment';
import { CommentHeader } from './comment-header';
import { CommentLoader } from './comment-loader';
export function CommentList() {
  const $ = _c(30);
  const {
    slug,
    sort
  } = useCommentsContext();
  const [params] = useCommentParams();
  const t = useTranslations();
  let t0;
  if ($[0] !== params.comment || $[1] !== slug || $[2] !== sort) {
    t0 = pageParam => ({
      slug,
      sort,
      type: "comments",
      highlightedCommentId: params.comment ?? undefined,
      cursor: pageParam
    });
    $[0] = params.comment;
    $[1] = slug;
    $[2] = sort;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const {
    data,
    isSuccess,
    isLoading,
    isError,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage
  } = useListComments(t0);
  const {
    ref,
    inView
  } = useInView();
  let t1;
  let t2;
  if ($[4] !== fetchNextPage || $[5] !== hasNextPage || $[6] !== inView) {
    t1 = () => {
      if (inView && hasNextPage) {
        fetchNextPage();
      }
    };
    t2 = [fetchNextPage, hasNextPage, inView];
    $[4] = fetchNextPage;
    $[5] = hasNextPage;
    $[6] = inView;
    $[7] = t1;
    $[8] = t2;
  } else {
    t1 = $[7];
    t2 = $[8];
  }
  useEffect(t1, t2);
  const noComments = isSuccess && data.pages[0]?.comments.length === 0;
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CommentHeader />;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== data || $[11] !== isSuccess) {
    t4 = isSuccess && data.pages.map(_temp2);
    $[10] = data;
    $[11] = isSuccess;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== isFetchingNextPage || $[14] !== isLoading) {
    t5 = (isLoading || isFetchingNextPage) && <CommentLoader />;
    $[13] = isFetchingNextPage;
    $[14] = isLoading;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== isError || $[17] !== t) {
    t6 = isError && <div className="flex min-h-20 items-center justify-center"><p className="text-sm text-muted-foreground">{t("error.failed-to-load-comments")}</p></div>;
    $[16] = isError;
    $[17] = t;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== noComments || $[20] !== t) {
    t7 = noComments && <div className="flex min-h-20 items-center justify-center"><p className="text-sm text-muted-foreground">{t("blog.comments.no-comments")}</p></div>;
    $[19] = noComments;
    $[20] = t;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== ref) {
    t8 = <span ref={ref} className="invisible" />;
    $[22] = ref;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t4 || $[25] !== t5 || $[26] !== t6 || $[27] !== t7 || $[28] !== t8) {
    t9 = <>{t3}<div className="space-y-8 py-2" data-testid="comments-list">{t4}{t5}{t6}{t7}{t8}</div></>;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  return t9;
}
function _temp2(page) {
  return page.comments.map(_temp);
}
function _temp(comment) {
  return <Comment key={comment.id} comment={comment} />;
}